import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface SendOrderToDriverModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: (orderId: number) => void;
  driverName: string;
  loading?: boolean;
}

const SendOrderToDriverModal: React.FC<SendOrderToDriverModalProps> = ({
  isOpen,
  onClose,
  onSend,
  driverName,
  loading = false
}) => {
  const { t } = useTranslation();
  const [orderId, setOrderId] = useState<string>('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (orderId && !isNaN(parseInt(orderId))) {
      onSend(parseInt(orderId));
    }
  };

  const handleClose = () => {
    setOrderId('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={t('modals.sendOrderToDriver.title')}>
      <form onSubmit={handleSubmit} className="modal-form">
        <div className="modal-form-group">
          <label>{t('modals.sendOrderToDriver.driver')}</label>
          <div style={{
            padding: '0.75rem',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            fontWeight: 500
          }}>
            {driverName}
          </div>
        </div>

        <div className="modal-form-group">
          <label htmlFor="orderId">{t('modals.sendOrderToDriver.orderIdLabel')}</label>
          <input
            type="number"
            id="orderId"
            value={orderId}
            onChange={(e) => setOrderId(e.target.value)}
            placeholder={t('modals.sendOrderToDriver.orderIdPlaceholder')}
            required
            disabled={loading}
            min="1"
          />
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={handleClose}
            className="modal-button secondary"
            disabled={loading}
          >
            {t('modals.sendOrderToDriver.cancel')}
          </button>
          <button
            type="submit"
            className="modal-button primary"
            disabled={loading || !orderId || isNaN(parseInt(orderId))}
          >
            {loading ? t('modals.sendOrderToDriver.sending') : t('modals.sendOrderToDriver.send')}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default SendOrderToDriverModal;
